<template>
    <div class="progress-bar">
        <div class="progress-bar__value">
            {{ progress }}%
        </div>
        <div class="progress-bar__progress-container">
            <div class="progress-bar__progress"
                 :style="{ width: progress + '%' }"
            />
        </div>
        <div class="progress-bar__text">
            {{ message }}
        </div>
        <div v-if="allowCancel"
             class="progress-bar__cancel"
        >
            <base-button id="cancelAction"
                         primary
                         @click="$emit('cancel')"
            >
                {{ cancelText }}
            </base-button>
        </div>
    </div>
</template>

<script>
import { BaseButton } from '@/components/buttons';

export default {
    name: 'ProgressBar',
    components: { BaseButton },
    props: {
        value: {
            type: Number,
            required: true,
        },
        message: {
            type: String,
            default: 'Uploading...',
        },
        allowCancel: {
            type: Boolean,
            default: false,
        },
        cancelText: {
            type: String,
            default: 'Cancel',
        },
    },
    computed: {
        progress() {
            if (!this.value || this.value < 0) {
                return 0;
            }
            if (this.value > 100) {
                return 100;
            }
            return this.value;
        },
    },
};
</script>

<style scoped lang="scss">
.progress-bar {
    flex: 1;
    text-align: center;

    &__value {
        font-family: $font-family-secondary;
        font-size: 2 * $font-size-md;
        font-weight: 300;
    }

    &__progress-container {
        max-width: 975px;
        height: 22px;
        margin: 25px auto;
        overflow: hidden;
        border-radius: 11px;
        background: $color-gray-800;
    }

    &__progress {
        width: 50%;
        height: 22px;
        transition: width .3s ease;
        background: $color-teal-650;
    }

    &__cancel {
        margin: 25px auto;
    }

    &__text {
        color: $color-gray-400;
        font-family: $font-family-primary;
        font-size: $font-size-md;
        font-weight: 500;
    }
}
</style>
